/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Etos_ImportExportEto_TransactionImportEto } from '../models/Wealthlane_Shared_Hosting_Etos_ImportExportEto_TransactionImportEto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransactionImportEventHandlerService {

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransactionImportEventHandlerTransactionImportEventHandler(
requestBody?: Wealthlane_Shared_Hosting_Etos_ImportExportEto_TransactionImportEto,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transaction-import-event-handler/transaction-import-event-handler',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
